import { render, staticRenderFns } from "./GooglePlayReplyReview.vue?vue&type=template&id=1c949812&scoped=true"
import script from "./GooglePlayReplyReview.vue?vue&type=script&lang=js"
export * from "./GooglePlayReplyReview.vue?vue&type=script&lang=js"
import style0 from "./GooglePlayReplyReview.vue?vue&type=style&index=0&id=1c949812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c949812",
  null
  
)

export default component.exports